<template>

    <images
        :images-uri="route('api.v1.images.index', {project_uuid:project.uuid})"
    ></images>

</template>

<script>

    import { mapGetters } from 'vuex';
    import Lang from '../../../Lang';
    import Images from "../../../components/Images/Images";

    export default {

        components: {
            Images,
        },

        computed: {
            ...mapGetters([
                'getProject',
            ]),

            project() {
                return this.getProject;
            },
        },

        data() {
            return {
                Lang:Lang,
            }
        },

        metaInfo: {
            title:'Project afbeeldingen',
        },

        name:'ProjectsDetailsImages',

    }

</script>
